import {navigate} from '../../../../../utils/navigation';
import ModalsLib from '../../../../../lib/modals';
import NotificationTimer from './notification_timer';

export default ({
    id,
    type,
    module: module_,
    details,
    is_read,
    timestamp,
    toggleFunc
}) => {
    return (
        <div className="notification" style={{
            cursor: details.details.handler ? 'pointer' : 'default'
        }} onClick={e => {
            if(details.details.handler) {
                if(details.details.handler.type === "path") {
                    toggleFunc();
                    navigate(details.details.handler.value);
                }

                if(details.details.handler.type === "modal") {
                    toggleFunc();
                    ModalsLib.open(details.details.handler.value);
                }
            }
        }}> 
            <div className={`border notification-border-type-${type} notification-border-module-${module_}`}></div>
            <div className="notification-content">
                <div className="notification-details">
                    <div className="notification-header">
                        <div className="notification-title">{details.details.title}</div>
                        <div className="notification-time">
                            <NotificationTimer id={id} timestamp={timestamp} />
                        </div>
                    </div>
                    <div className="notification-text" dangerouslySetInnerHTML={{__html: details.details.text}}></div>
                </div>
            </div>
        </div>
    )
}